
    import { defineComponent, PropType } from 'vue';
    import { ILibraryComponent, ILibraryComponentCategory } from '../library/types';

    export default defineComponent({
        name: "LibrarySideBarMenu",
        props: {
            title: { type: String, required: true },
            categories: { type: Object as PropType<ILibraryComponentCategory[]>, required: true },
        },
        emits: ['componentSelected'],
        setup(_props, _context) {
        },
        methods: {
            handleComponentSelected(comp: ILibraryComponent) {
                this.$emit("componentSelected", comp);
            },
            getLibraryComponents(cat: ILibraryComponentCategory) {
                return cat?.components?.filter(c => c.libraryComponent != null) ?? [];
            }
        }
    });
